export default "__VITE_ASSET__DjgmuwMZ__"